"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useCreateGroup() {
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)('groups');
    return {
        createdGroup: data,
        isCreating: isLoading,
        error,
        createGroup: post
    };
}
exports.useCreateGroup = useCreateGroup;
//# sourceMappingURL=useCreateGroup.js.map